import { render, staticRenderFns } from "./typeclassxqpartner.vue?vue&type=template&id=31bd93fd&scoped=true"
import script from "./typeclassxqpartner.vue?vue&type=script&lang=js"
export * from "./typeclassxqpartner.vue?vue&type=script&lang=js"
import style0 from "./typeclassxqpartner.vue?vue&type=style&index=0&id=31bd93fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd93fd",
  null
  
)

export default component.exports